import { useSelector } from 'react-redux';
import Disclaimer from '../../../component/disclaimer';
import { IconDoubleRightArrow } from '../../../component/icon/double-right-arrow';
import './bigNumbers.scss';
import { BigNumbersData, DataSource } from './types';
import { useBigNumbersData } from './useBigNumbersData';

type TBigNumber = {
  key?: string;
  value?: string | number;
  primary_percentual_oscillation: {
    period: string;
  };
  secondary_percentual_oscillation: {
    period: string;
  };
  transactions_percentual_oscillation: {
    period: string;
  };
};

type TBigNumberProps = {
  bigNumbers: BigNumbersData;
  indicatorsAction?: () => void;
  skipFormatting?: boolean;
  dataSource?: DataSource;
};

const defaultDataSource: DataSource = { display: false, data: {} };
const BigNumbers = ({
  bigNumbers,
  indicatorsAction,
  skipFormatting = false,
  dataSource = defaultDataSource,
}: TBigNumberProps): JSX.Element => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const { displayCharts } = useSelector((state: any) => state.dashboardState);
  const nls = require(`./nls/${preference.language.id}.json`);
  const { formattedData, periods } = useBigNumbersData(
    bigNumbers,
    displayCharts,
    skipFormatting
  );
  return (
    displayCharts && (
      <div className="big-numbers-external-container">
        <div className="big-numbers-header-container">
          <div className="big-numbers-header">
            <h1>{nls.regionResults}</h1>
            <a
              data-cy="BigNumbersIndicatorsBtn"
              className="btn"
              href="#charts-page"
              onClick={() => {
                if (indicatorsAction) {
                  indicatorsAction();
                }
              }}
            >
              <div className="big-numbers-indicators-btn">
                <span>{nls.indicators}</span>
                <IconDoubleRightArrow
                  cy={'BigNumbersIconDoubleRightArrow'}
                  fill="#793EAD"
                />
              </div>
            </a>
          </div>
        </div>
        <div className="big-numbers-internal-container">
          {formattedData &&
            Object.entries(formattedData).map(
              (el: [string, unknown], index) =>
                el[1] && (
                  <div className="big-numbers--card" key={index}>
                    <h5
                      className="big-numbers--card-title"
                      data-cy={`BigNumbersTitle[${index}]`}
                    >
                      {el[1] as number}
                    </h5>
                    <div className="big-numbers--value--container">
                      <p
                        className="big-numbers--card--value"
                        data-cy={`BigNumbersValue[${index}]`}
                      >
                        {nls[el[0]]}
                      </p>
                      {dataSource?.display && (
                        <Disclaimer
                          colorIcon="#6F7171"
                          cy="BigNumbersSocioeconomic"
                          element={dataSource?.data[el[0]]}
                          position="top"
                        />
                      )}
                      {periods && (
                        <span style={{ fontSize: 10 }}>{periods[el[0]]}</span>
                      )}
                    </div>
                  </div>
                )
            )}
        </div>
      </div>
    )
  );
};

export default BigNumbers;
